<template>
  <div>
    <!-- For Text -->
    <div v-html="data.questionFreeText"></div>

    <br />

    <div v-html="data.questionYoutubeLink"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => {}
    }
  }
};
</script>
